function _print(element) {
    function printFrame(frameWindow, timeout) {
        // Print the selected window/iframe
        setTimeout(function() {
            // Fix for IE: Allow it to render the iframe
            frameWindow.focus();
            try {
                // Fix for IE11: printing the whole page instead of the iframe content
                if (!frameWindow.document.execCommand('print', false, null)) {
                    // document.execCommand returns false if it failed - http://stackoverflow.com/a/21336448/937891
                    frameWindow.print();
                }
            } catch(e) {
                frameWindow.print();
            }
            frameWindow.close();
        }, timeout);
    }
    
    function printContentInNewWindow(content, timeout) {
        // Open a new window and print selected content
        var w = window.open();
        w.document.write(content);
        w.document.close();
        return printFrame(w, timeout);
    }
    
    // Create a copy of the element to print
    var clone;
    var content;
    if (element.tagName == 'TEMPLATE') {
        content = element.innerHTML;
    } else {
        clone = element.cloneNode(true);
        content = clone.outerHTML;
    }
    
    // Destroy the copy
    clone = null;
    
    printContentInNewWindow(content, 250);
};